export const ACTION_IN_PROGRESS = 'user/ACTION_IN_PROGRESS';

export const LOAD_USERS_REQUEST = 'user/LOAD_USERS_REQUEST';
export const LOAD_USERS_SUCCESS = 'user/LOAD_USERS_SUCCESS';

export const SAVE_USER_REQUEST = 'user/SAVE_USER_REQUEST';
export const SAVE_USER_SUCCESS = 'user/SAVE_USER_SUCCESS';
